export default __webpack_public_path__ + "static/Group 434-9c8ebd344015bd0a2989071b8ffe3857.png";